export function getUniqueKeys(arrayOfObjects) {
  if (!arrayOfObjects || !Array.isArray(arrayOfObjects)) {
    return [];
  }
  const uniqueKeys = new Set();
  
  for (const obj of arrayOfObjects) {
      Object.keys(obj).forEach(key => uniqueKeys.add(key));
  }
  
  return Array.from(uniqueKeys) as string[];
}
